module.exports = __webpack_public_path__ + "img/24.5602c2e9.png";